import { CarouselService } from '@alliance/shared/carousel-gallery'
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { Translations } from '../localization/translations'
import { CAROUSEL_SELECTOR } from '../constants/carousel'

@Component({
  selector: 'lib-category-navigation',
  templateUrl: './category-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryNavigationComponent {
  public constructor(public translations: Translations, private carouselService: CarouselService) {}

  public toPrevious(): void {
    this.carouselService.prev(1, CAROUSEL_SELECTOR)
  }

  public toNext(): void {
    this.carouselService.next(1, CAROUSEL_SELECTOR)
  }
}
